(function() {
  var KX_RV = window.KX_PDP_RV_CONFIG || {};
  var sectionId = KX_RV.sectionId;
  var currentId = KX_RV.currentId;
  var wrapper   = document.getElementById('pdp-rv-' + sectionId);
  var track     = document.getElementById('pdp-rv-track-' + sectionId);
  if (!wrapper || !track) return;

  try {
    var ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]')
      .filter(function(id) { return id !== currentId; })
      .slice(0, 10);
    if (!ids.length) return;

    var url = new URL(window.location.origin + '/search');
    url.searchParams.set('section_id', 'product-recently-viewed-items');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', ids.map(function(id) { return 'id:' + id; }).join(' OR '));

    fetch(url.toString())
      .then(function(r) { return r.ok ? r.text() : null; })
      .then(function(html) {
        if (!html || !html.trim()) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var cards = Array.from(tmp.querySelectorAll('.pdp-rv-card'));
        if (!cards.length) return;
        cards.sort(function(a, b) {
          var ia = ids.indexOf(a.dataset.productId);
          var ib = ids.indexOf(b.dataset.productId);
          return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
        });
        cards.forEach(function(c, i) {
          c.style.animationDelay = (i * 60) + 'ms';
          track.appendChild(c);
        });
        wrapper.style.display = '';
        initCarousel();
      })
      .catch(function() {});
  } catch(e) {}

  function initCarousel() {
    var prev = wrapper.querySelector('.pdp-rv__arrow--prev');
    var next = wrapper.querySelector('.pdp-rv__arrow--next');
    if (!prev || !next) return;

    var scrollAmount = 240;

    function updateArrows() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    prev.addEventListener('click', function() {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    next.addEventListener('click', function() {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    var scrollTicking = false;
    track.addEventListener('scroll', function() {
      if (!scrollTicking) {
        scrollTicking = true;
        requestAnimationFrame(function() {
          updateArrows();
          scrollTicking = false;
        });
      }
    }, { passive: true });
    updateArrows();

    /* Re-initialize wishlist-heart elements if the custom element is defined */
    if (window.customElements && window.customElements.get('wishlist-heart')) {
      track.querySelectorAll('wishlist-heart').forEach(function(el) {
        if (typeof el.connectedCallback === 'function') {
          el.connectedCallback();
        }
      });
    }
  }

  /* ── AJAX Add to Cart handler ── */
  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('.pdp-rv-card__hover-atc');
    if (!btn || btn.disabled || btn.classList.contains('is-adding')) return;

    var variantId = btn.getAttribute('data-variant-id');
    var activeCard = btn.closest('.pdp-rv-card');
    if (!variantId) return;

    e.preventDefault();
    e.stopPropagation();

    if (activeCard) activeCard.classList.add('is-atc-active');
    wrapper.classList.add('is-atc-active');
    btn.classList.add('is-adding');
    btn.classList.remove('is-added');

    try {
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      // 1. Add to cart
      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: formData
      });
      var addedItem = await addRes.json();

      if (!addRes.ok) throw new Error('Add failed');

      // 2. Success animation
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');

      // 3. Fetch updated cart + sections for drawer
      var cartDrawer = document.querySelector('cart-drawer-component');
      var drawerSectionId = cartDrawer ? cartDrawer.dataset.sectionId : null;
      var sections = {};

      if (drawerSectionId) {
        var sectionsRes = await fetch(window.location.pathname + '?sections=' + drawerSectionId);
        sections = await sectionsRes.json();
      }

      var cartRes = await fetch('/cart.js');
      var cart = await cartRes.json();

      // 4. Dispatch cart:update (cart drawer auto-opens via its own listener)
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'pdp-rv-atc',
          data: {
            sections: sections,
            itemCount: cart.item_count
          }
        }
      }));

      // 5. Reset button after delay
      setTimeout(function() {
        btn.classList.remove('is-added');
        if (activeCard) activeCard.classList.remove('is-atc-active');
        wrapper.classList.remove('is-atc-active');
      }, 2000);

    } catch(err) {
      btn.classList.remove('is-adding');
      btn.textContent = 'Fehler';
      setTimeout(function() {
        btn.innerHTML = '<span class="pdp-rv-atc__text">' + KX_RV.addToCartLabel + '</span><span class="pdp-rv-atc__check"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span><span class="pdp-rv-atc__adding"><svg class="pdp-rv-atc__spinner" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#fff" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-dasharray="31.4" stroke-dashoffset="10"/></svg></span>';
        if (activeCard) activeCard.classList.remove('is-atc-active');
        wrapper.classList.remove('is-atc-active');
      }, 1500);
    }
  });
})();
